module.exports = __webpack_public_path__ + "static/media/react-redux.fd1eda48.jpg";